export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../../views/dashboard/Index'),
    meta: {
      title: 'Dashboard',
      activeMenu: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/dashboard/spklu-itdc-1',
    name: 'Dashboard ITDC 1',
    component: () => import('../../views/dashboard/Index'),
    meta: {
      title: 'Dashboard',
      activeMenu: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          disabled: true
        },
        {
          text: 'ITDC 1',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/dashboard/spklu-itdc-2',
    name: 'Dashboard ITDC 2',
    component: () => import('../../views/dashboard/Index'),
    meta: {
      title: 'Dashboard',
      activeMenu: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          disabled: true
        },
        {
          text: 'ITDC 2',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/dashboard/apurva-kempinski',
    name: 'Dashboard Apurva Kempinski',
    component: () => import('../../views/dashboard/Index'),
    meta: {
      title: 'Dashboard',
      activeMenu: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          disabled: true
        },
        {
          text: 'Apurva Kempinski',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/dashboard/spklu-ac',
    name: 'Dashboard SPKLU AC',
    component: () => import('../../views/dashboard/spklu_ac'),
    meta: {
      title: 'Dashboard',
      activeMenu: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          disabled: true
        },
        {
          text: 'SPKLU AC',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/dashboard/spklu-fast-charging',
    name: 'Dashboard SPKLU Fast Charging',
    component: () => import('../../views/dashboard/spklu_fast_charging'),
    meta: {
      title: 'Dashboard',
      activeMenu: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          disabled: true
        },
        {
          text: 'SPKLU Fast Charging',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/monitoring',
    name: 'Monitoring',
    component: () => import('../../views/dashboard/Index'),
    meta: {
      title: 'Monitoring',
      activeMenu: 'Monitoring',
      breadcrumb: [
        {
          text: 'Monitoring',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/monitoring/spklu-mobile',
    name: 'Monitoring SPKLU Mobile',
    component: () => import('../../views/monitoring/spklu_mobile'),
    meta: {
      title: 'Monitoring',
      activeMenu: 'Monitoring',
      breadcrumb: [
        {
          text: 'Monitoring',
          disabled: true
        },
        {
          text: 'SPKLU Mobile',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/monitoring/data-kendaraan',
    name: 'Monitoring Data Kendaraan',
    component: () => import('../../views/monitoring/data_kendaraan'),
    meta: {
      title: 'Monitoring',
      activeMenu: 'Monitoring',
      breadcrumb: [
        {
          text: 'Monitoring',
          disabled: true
        },
        {
          text: 'Data Kendaraan',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/transaksi/detail-transaksi',
    name: 'Detail Transaksi',
    component: () => import('../../views/transaksi/detail_transaksi'),
    meta: {
      title: 'Transaksi',
      activeMenu: 'Transaksi',
      breadcrumb: [
        {
          text: 'Transaksi',
          disabled: true
        },
        {
          text: 'Detail Transaksi',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/monitoring/detail-spklu-ac',
    name: 'Detail SPKLU AC',
    component: () => import('../../views/monitoring/detail_spklu_ac'),
    meta: {
      title: 'Monitoring',
      activeMenu: 'Monitoring',
      breadcrumb: [
        {
          text: 'Monitoring',
          disabled: true
        },
        {
          text: 'Detail SPKLU AC',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/monitoring/unavailable-spklu-dc',
    name: 'Unavailable SPKLU DC',
    component: () => import('../../views/monitoring/unavailable_spklu_dc'),
    meta: {
      title: 'Monitoring',
      activeMenu: 'Monitoring',
      breadcrumb: [
        {
          text: 'Monitoring',
          disabled: true
        },
        {
          text: 'Unavailable SPKLU DC',
          disabled: true
        }
      ]
    }
  }
  // {
  //   path: '/transaksi/aktivasi-user-pascabayar',
  //   name: 'Aktivasi User Pascabayar',
  //   component: () => import('../../views/transaksi/aktivasi_user_pasca'),
  //   meta: {
  //     title: 'Transaksi',
  //     activeMenu: 'Transaksi',
  //     breadcrumb: [
  //       {
  //         text: 'Transaksi',
  //         disabled: true
  //       },
  //       {
  //         text: 'Aktivasi User Pascabayar',
  //         disabled: true
  //       }
  //     ]
  //   }
  // }
]
